export default __webpack_public_path__ + "static/media/fairview.26e565da.png";